module.exports = __webpack_public_path__ + "static/media/joiningfiles.209d15cb.md";